import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { Global, css } from '@emotion/react';
import { Colors } from '@zapier/design-system';
import { labelStyles } from '@zapier/style-encapsulation';
import { MEDIA_MIN_WIDTH } from '../../constants';
import { useTracking } from '../../tracking';
import { CustomBrandButton } from './CustomBrandButton';
const Styles = labelStyles('CustomCTAFilled', {
    root: (backgroundColor) => css({
        padding: '96px 20px',
        backgroundColor: Colors[backgroundColor !== null && backgroundColor !== void 0 ? backgroundColor : 'earth'],
        [MEDIA_MIN_WIDTH.large]: {
            padding: '120px 20px',
        },
    }),
    content: css({
        maxWidth: '544px',
        margin: '0 auto',
        textAlign: 'center',
        [MEDIA_MIN_WIDTH.large]: {
            maxWidth: '832px',
        },
    }),
    heading: css({
        fontFamily: 'GT Alpina, serif',
        fontSize: '36px',
        fontWeight: 200,
        lineHeight: 1.1,
        letterSpacing: '-1px',
        color: Colors.neutral100,
        WebkitFontSmoothing: 'antialiased',
        MozOsxFontSmoothing: 'grayscale',
        [MEDIA_MIN_WIDTH.small]: {
            fontSize: '50px',
            letterSpacing: '-1.5px',
        },
        [MEDIA_MIN_WIDTH.large]: {
            fontSize: '74px',
            letterSpacing: '-2px',
        },
    }),
    button: css({
        marginTop: '26px',
        [MEDIA_MIN_WIDTH.large]: {
            marginTop: '50px',
        },
    }),
});
export function CustomCTACentered(props) {
    var _a, _b;
    const { emitUserInteractionEvent } = useTracking();
    return (_jsxs(_Fragment, { children: [_jsx(Global, { styles: css({
                    '@font-face': {
                        fontFamily: 'GT Alpina',
                        fontStyle: 'normal',
                        fontWeight: 200,
                        fontDisplay: 'swap',
                        src: 'url("https://res.cloudinary.com/zapier-media/raw/upload/fonts/GT%20Alpina/GT-Alpina-Standard-Thin.woff2") format("woff2")',
                    },
                }) }), _jsx("div", Object.assign({ css: Styles.root(props.backgroundColor) }, { children: _jsxs("div", Object.assign({ css: Styles.content }, { children: [_jsx("div", { children: props.children }), _jsxs("div", { children: [_jsx("h2", Object.assign({ css: Styles.heading }, { children: props.heading })), ((_a = props.button) === null || _a === void 0 ? void 0 : _a.text) && ((_b = props.button) === null || _b === void 0 ? void 0 : _b.url) && (_jsx("div", Object.assign({ css: Styles.button }, { children: _jsx(CustomBrandButton, Object.assign({ href: props.button.url, variant: props.button.variant, onClick: () => {
                                            var _a, _b, _c, _d;
                                            emitUserInteractionEvent({
                                                event_action: 'click',
                                                interaction_name: 'call_to_action',
                                                interaction_raw_text: (_b = (_a = props.button) === null || _a === void 0 ? void 0 : _a.text) !== null && _b !== void 0 ? _b : '',
                                                destination_href: (_d = (_c = props.button) === null || _c === void 0 ? void 0 : _c.url) !== null && _d !== void 0 ? _d : '',
                                                option_selected: 'cta_button',
                                            });
                                        } }, { children: props.button.text })) })))] })] })) }))] }));
}
//# sourceMappingURL=CustomCTACentered.js.map